import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import es from "./locales/es.json";
import en from "./locales/en.json";

type Lang = "es" | "en";

const detectLanguage = (): Lang => {
  if (typeof window === "undefined") return "en";
  try {
    const stored = window.localStorage.getItem("itac_language");
    if (stored === "es" || stored === "en") return stored;
  } catch {
    /* storage unavailable */
  }
  const nav = window.navigator?.language || document.documentElement.lang || "en";
  return nav.toLowerCase().startsWith("es") ? "es" : "en";
};

const initialLng = detectLanguage();

i18n.use(initReactI18next).init({
  resources: {
    es: { translation: es },
    en: { translation: en },
  },
  lng: initialLng,
  fallbackLng: "es",
  supportedLngs: ["en", "es"],
  interpolation: {
    escapeValue: false,
  },
  react: {
    bindI18n: "languageChanged",
  },
});

i18n.on("languageChanged", (lng) => {
  const next = (lng?.toLowerCase().startsWith("es") ? "es" : "en") as Lang;
  try {
    window.localStorage.setItem("itac_language", next);
  } catch {
    /* storage unavailable */
  }
  document.documentElement.lang = next;
});

if (typeof document !== "undefined") {
  document.documentElement.lang = initialLng;
}

export default i18n;
